import { ActivityContainer } from '@/features/activity/ActivityContainer'

export function Activity() {
  return <ActivityContainer />
}
